/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import '../config/carouselStyles.css';
import FsLightbox from 'fslightbox-react';
import { classNames } from '../util/functions';
import useWindowDimensions from '../hooks/useWindowDimensions';

const PhotosCarousel = ({ photos, children, customStyles, imgStyles, postId }) => {
  const { width } = useWindowDimensions();
  const [toggler, setToggler] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (postId) setCurrentIndex(0);
  }, [postId]);

  const slideHeight = width > 480 ? 450 : 'auto';
  const showThumbs = width > 480;

  return (
    <div className={classNames('photos-wrapper relative', customStyles)}>
      <div className="bg-black bg-opacity-75 absolute top-3 left-2 z-10 rounded-lg py-1 px-4">
        <p className="text-white text-sm">{`${currentIndex + 1} of ${photos?.length}`}</p>
      </div>

      <Carousel
        key={postId}
        swipeable
        dynamicHeight
        showArrows={true}
        className="relative"
        showThumbs={showThumbs}
        renderThumbs={() => photos.map((item, i) => (
          <img src={item} key={`thumb-${i}`} className="thumb-img" alt={`thumb ${i}`} />
        ))}
        onChange={(index) => setCurrentIndex(index)}
        emulateTouch
      >
        {photos.map((item, index) => (
          <button
            type="button"
            key={`slide${index + 1}`}
            className="slide-wrapper"
            style={{ height: slideHeight }}
            onClick={() => setToggler(!toggler)}
          >
            <img
              src={item}
              alt={`photo-${index}`}
              loading="lazy"
              className={classNames('slide-img', imgStyles)}
            />
          </button>
        ))}
      </Carousel>

      {!!children && children}
      <FsLightbox toggler={toggler} sourceIndex={currentIndex} type="image" sources={photos} />
    </div>
  );
};

PhotosCarousel.defaultProps = {
  photos: [],
};
const propsAreEqual = (prev, next) => prev?.postId === next?.postId
  && prev?.photos?.length === next?.photos?.length;

// export default React.memo(PhotosCarousel, propsAreEqual);
export default React.memo(PhotosCarousel);
